import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  period: {
    '@$': 'focusedRange',
  },
  selection: {
    '{}': {
      name: {
        '++': [
          {
            '@$': 'financialVolume',
          },
          ' Expense by Department',
        ],
      },
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  slices: {
                    '@': 'expenseQuery',
                  },
                },
              },
            ],
          },
          type: 'donut',
        },
      },
      overflowActions: {
        '[]': [
          {
            '{}': {
              icon: 'atn-icon atn-link',
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      goto: {
                        '{}': {
                          segmentId: 'org',
                          navigationId: 'explore',
                        },
                      },
                    },
                  },
                  operation: 'ui.navigate',
                },
              },
            },
          },
        ],
      },
    },
  },
  variables: {
    shouldAnalyze: true,
  },
  subqueries: {
    expenseQuery: {
      sort: {
        by: {
          '??': [
            {
              '+': {
                '@': 'expenses',
              },
            },
            0,
          ],
        },
        descending: true,
      },
      filter: {
        if: [
          [
            {
              '=': [
                {
                  '@$': 'shouldAnalyze',
                },
                true,
              ],
            },
            {
              '=': [
                {
                  '@.': '!should_analyze',
                },
                true,
              ],
            },
          ],
          true,
        ],
      },
      target: 'dim::!org',
      selection: {
        '{}': {
          name: {
            '@.': '!name',
          },
          value: {
            '??': [
              {
                '+': {
                  '@': 'expenses',
                },
              },
              0,
            ],
          },
          onClick: {
            '{}': {
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      goto: {
                        '{}': {
                          variables: {
                            '{}': {
                              orgEntityId: {
                                '@_': 'id',
                              },
                              orgRecordId: {
                                '@.': '!id',
                              },
                            },
                          },
                          navigationId: 'explore',
                        },
                      },
                    },
                  },
                  operation: 'ui.navigate',
                },
              },
            },
          },
        },
      },
      subqueries: {
        expenses: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projectAssignments',
          filter: {
            and: [
              {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@$': 'financialVolume',
                        },
                        'MTDC',
                      ],
                    },
                    {
                      '@': 'isInMtdc',
                    },
                  ],
                  true,
                ],
              },
              {
                or: [
                  {
                    '=': [
                      {
                        '@$': 'researchType',
                      },
                      null,
                    ],
                  },
                  {
                    in: [
                      {
                        '@': 'researchType',
                      },
                      {
                        '@$': 'researchType',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
          subqueries: {
            isInMtdc: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!acct',
              },
              target: 'ent:!gl_accts:!acct',
              selection: {
                '@.': '!is_in_mtdc',
              },
            },
            researchType: {
              ref: {
                attr: 'attr:ent#!gl_exp#!entry:!proj',
              },
              target: 'ent:!projects:!proj',
              selection: {
                '@.': '!research_type_wfuhs',
              },
            },
          },
        },
        projectAssignments: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
            inherit: '-',
          },
          target: 'ent:!projects:!proj',
        },
      },
    },
  },
}
